module.exports = "https://static.wagwalking.com/_next/static/images/pet-care-desktop-b696fd44c49fe44c74f0fb5c37f4ab2c.webp";